export const RESET_ALL_STATE = 'RESET_ALL_STATE';
export function initializeModule(mod) {
  const modulesToProcess = [mod];
  // Traverse breadth-first the modules, switching the state function for its result and adding the
  // mutation for clearing the state. Inspired by: https://medium.com/@Taha_Shashtari/reset-vuex-module-state-like-a-pro-1acb7f8d9e21
  while (modulesToProcess.length > 0) {
    const module = modulesToProcess.pop();
    if (module.state) {
      const recreateState = module.state;
      if (!module.mutations) {
        module.mutations = {};
      }
      module.mutations[RESET_ALL_STATE] = (state) => {
        Object.assign(state, recreateState());
      };

      module.state = module.state();
    }
    if (module.modules) {
      const modules = Object.values(module.modules);
      if (modules.length > 0) {
        modulesToProcess.push(...modules);
      }
    }
  }
}
